import { createSelector } from '@reduxjs/toolkit'
import { layoutTimelineItems } from '@utils/timeline_item_placement.js'
import { clamp } from '@utils/math.ts'
import { getHorizontalVizBase, firstAndLastDateSelector } from './general_selectors.js'
import { scrollerSelector, paddedDurationSelector, timelineItemScalePositionsSelector } from './scroller_selectors.js'
import { stageWidthSelector, stageHeightSelector } from './stage_selectors.js'

// margin around expanded items
const EXPANDED_MARGIN = 40
const DOUBLED_MARGIN = EXPANDED_MARGIN * 2
const MIN_EXPANDED_WIDTH = 100
const MIN_EXPANDED_HEIGHT = 100
const MAX_EXPANDED_WIDTH = 460
const MAX_EXPANDED_HEIGHT = 580

export const getDrilledDownTimelineItem = (state, props) => {
  const base = getHorizontalVizBase(state)
  return base.drilledDownItem
}

export const expandedItemBoundsSelector = createSelector(
  stageWidthSelector,
  stageHeightSelector,
  function (stageWidth, stageHeight) {
    const width = clamp(stageWidth - DOUBLED_MARGIN, MIN_EXPANDED_WIDTH, MAX_EXPANDED_WIDTH)
    const height = clamp(stageHeight - DOUBLED_MARGIN, MIN_EXPANDED_HEIGHT, MAX_EXPANDED_HEIGHT)
    return {
      x: stageWidth / 2 - width / 2,
      y: stageHeight / 2 - height / 2,
      width,
      height,
    }
  }
)

// lays out timeline items
export const displayableTimelineItemsSelector = createSelector(
  scrollerSelector,
  timelineItemScalePositionsSelector,
  firstAndLastDateSelector,
  paddedDurationSelector,
  (state, props) => props.markers,
  (state, props) => props.timespans,
  function (scrollerData, timelineItemScalePositions, firstAndLastDate, paddedDurationData, markers, timespans) {
    //console.log("Running expensive displayableTimelineItemsSelector. We are actually laying out all the items here.... this should not happen if just scrolling the timeline!!!!! Perhaps just grab the surface width instead of scrollerData? If optimizing, check all inputs are immutable")
    const dimensions = {
      x: scrollerData.surface.x,
      y: scrollerData.surface.y,
      width: scrollerData.surface.width,
      height: scrollerData.surface.height,
    }
    return layoutTimelineItems(dimensions, timelineItemScalePositions)
  }
)

// the position and size of the timeline viewport
export const timelineBoundsSelector = createSelector(scrollerSelector, function (scrollerData) {
  return {
    surface: scrollerData.surface,
    viewport: scrollerData.viewport,
  }
})

export const cursorSelector = createSelector(timelineBoundsSelector, function (timelineBounds) {
  const diff = timelineBounds.surface.width - timelineBounds.viewport.width
  return diff >= 1 ? 'move' : 'auto'
})
